var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstagram2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0225 7.08301C15.7128 7.08301 16.2725 6.52336 16.2725 5.83301C16.2725 5.14265 15.7128 4.58301 15.0225 4.58301C14.3321 4.58301 13.7725 5.14265 13.7725 5.83301C13.7725 6.52336 14.3321 7.08301 15.0225 7.08301Z",
    fill: "#565656"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1888 2.5C16.4888 2.5 18.3555 4.36667 18.3555 6.66667V13.3333C18.3555 15.6333 16.4888 17.5 14.1888 17.5H7.52214C5.22214 17.5 3.35547 15.6333 3.35547 13.3333V6.66667C3.35547 4.36667 5.22214 2.5 7.52214 2.5H10.8555H14.1888Z",
    stroke: "#565656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8558 6.66699C12.6975 6.66699 14.1891 8.15866 14.1891 10.0003C14.1891 11.842 12.6975 13.3337 10.8558 13.3337C9.01413 13.3337 7.52246 11.842 7.52246 10.0003C7.52246 8.15866 9.01413 6.66699 10.8558 6.66699Z",
    stroke: "#565656",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram2);
export default __webpack_public_path__ + "static/media/instagram2.af1ef99e6d7d9665f07bb5017fe4aef8.svg";
export { ForwardRef as ReactComponent };